import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  DsButtonV2Component,
  DsContentSheetComponent,  
} from '@customdesignsystem';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pi-modal-mensaje-generico-pasos',
  standalone: true,
  imports: [
    CommonModule,    
    DsButtonV2Component,
    DsContentSheetComponent
  ],  
  templateUrl: './pi-modal-mensaje-generico.component.html',
  styleUrls: ['./pi-modal-mensaje-generico.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PiModalMensajeGenericoPasosComponent {

  sheetVisible = true;

  @Input() title = '';
  @Input() subtitle = '';
  @Input() primaryButtonText = '';
  @Input() secondaryButtonText = '';
  @Input() urlDestino = '/';
  @Output() closed = new EventEmitter<void>();

  constructor(private readonly router: Router) {}

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.cerrar();
  }

  cerrar(): void {
    this.sheetVisible = false;
    this.closed.emit();
  }

  goToPage(): void {
    // Implement navigation logic here
    console.log('Navigating to page...');
     this.router.navigate([`${this.urlDestino}`]);
    this.sheetVisible = false;
  }
}